import{Z as s,d as o}from"./p-BspprXxR.js";const p=s;const r=o;export{p as ZprDropdownMenu,r as defineCustomElement};
//# sourceMappingURL=zpr-dropdown-menu.js.map